import { extend, override } from "flarum/extend";
import addUniLoginButton from "./addUniLoginButton";
import HeaderSecondary from "flarum/components/HeaderSecondary";
import SettingsPage from "flarum/components/SettingsPage";
import LogInModal from 'flarum/components/LogInModal';

export default function overwriteLoginFunctionality() {
  extend(HeaderSecondary.prototype, 'items', function(items) {
    // Replace login button with redirection to UniLogin
    if (items.has('logIn')) {
      items.remove('logIn');
      addUniLoginButton(items);
    }

    // Simply remove signup button
    if (items.has('signUp')) {
      items.remove('signUp');
    }
  });

  extend(SettingsPage.prototype, 'accountItems', function(items) {
    // Password management is delegated to UniLogin
    // Better hide it from here
    items.remove('changeEmail');
    items.remove('changePassword');
  });

  extend(SettingsPage.prototype, 'settingsItems', function(items) {
    // Account management is mostly delegated to UniLogin
    // Better hide this from here
    if (items.has('account')
      && items.get('account').children.length === 0) {
      items.remove('account');
    }
  });

  extend(LogInModal.prototype, 'fields', function (items) {
    items.remove('identification');
    items.remove('password');
    items.remove('remember');
    items.remove('submit');

    addUniLoginButton(items);

    return items;
  });

  override(LogInModal.prototype, 'footer', function () {
    // Hide hint for forgot password etc
    return [ ];
  });

}
